import React, { useState, useEffect } from "react";
import { Row, Col, Card, Typography, Button, message, Divider, Input, Tooltip, Form, Modal, Select, Space } from "antd";
import { EditOutlined, PlusOutlined, DeleteOutlined, UnorderedListOutlined, CopyOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate } from "react-router-dom";
import http from "../../../services/http";
import { TableCustom } from "../../../components/table";
const { Text } = Typography;

// STATUS
const options_status = [
  { value: 0, label: "Inativo" },
  { value: 1, label: "Ativo" },
];

export const AvaliacoesCadFormularios = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modal, contextHolder] = Modal.useModal();

  // ID ALTERAÇÃO
  const [idAlt, setIdAlt] = useState(0);

  const [classificacoes, setClassificacoes] = useState([]);

  useEffect(() => {
    carregarClassificacao();
    listarFormulario();
  }, []);

  // CARREGAR FORMULÁRIO
  const carregarClassificacao = async () => {
    setLoading(true);
    const api = await http("get", `v1/cargos_estrutura/listar_ativos`, []);
    if (api.statusCode === 200) {
      const array_class = [];
      api?.response?.data?.forEach((element) => {
        array_class.push({ value: element.id, label: element.descricao });
      });
      setClassificacoes(array_class);
    } else {
      navigate("/avaliacoes/formularios");
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // LISTAR
  const listarFormulario = async (id) => {
    setLoading(true);
    const api = await http("get", `v1/avaliacoes_formularios/listar`, []);
    if (api.statusCode === 200) {
      setDados(api?.response?.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CADASTRAR
  const cadastrarFormulario = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/avaliacoes_formularios/adicionar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro cadastrado com sucesso!");
      setShowModal(false);
      resetForm();
      listarFormulario();
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // ALTERAR
  const alterarFormulario = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/avaliacoes_formularios/alterar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro alterado com sucesso!");
      setShowModal(false);
      resetForm();
      listarFormulario();
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CARREGAR
  const carregarFormulario = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/avaliacoes_formularios/carregar/${id}`, []);
    if (api.statusCode === 200) {
      setShowModal(true);
      resetForm();
      form.setFieldsValue({
        descricao: api.response.data.descricao,
        id_cad_cargos_estrutura: api.response.data.id_cad_cargos_estrutura,
        status: api.response.data.status,
      });
      setIdAlt(api.response.data.id);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // DELETAR
  const deletarFormulario = async (id) => {
    setLoading(true);
    const api = await http("post", `v1/avaliacoes_formularios/deletar`, { id: id });
    if (api.statusCode === 200) {
      message.success("Registro deletado com sucesso!");
      listarFormulario();
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // DUPLICAR
  const duplicarFormulario = async (id) => {
    setLoading(true);
    const api = await http("post", `v1/avaliacoes_formularios/duplicar`, { id: id });
    if (api.statusCode === 200) {
      message.success("Registro duplicado com sucesso!");
      listarFormulario();
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // RESET FORM
  const resetForm = () => {
    form.resetFields();
    setIdAlt(0);
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: "Descrição",
      dataIndex: "descricao",
    },
    {
      title: "Classificação",
      dataIndex: "cargos_estrutura",
    },
    {
      dataIndex: "status",
      title: "Status",
      render: (_, e) => (e.status === 1 ? "Ativo" : "Inativo"),
      renderText: (e) => (e.status === 1 ? "Ativo" : "Inativo"),
    },
    {
      dataIndex: "acoes",
      title: "Ações",
      width: 150,
      sorter: false,
      render: (_, e) => (
        <Space.Compact>
          <Tooltip title="Grupos">
            <Button
              loading={loading}
              onClick={() => navigate(`/avaliacoes/formularios/grupos/${e.id}`)}
              icon={<UnorderedListOutlined />}
            />
          </Tooltip>
          <Tooltip title="Duplicar">
            <Button
              loading={loading}
              icon={<CopyOutlined />}
              onClick={() => {
                modal.confirm({
                  title: "Deseja duplicar este registro?",
                  okText: "Sim",
                  cancelText: "Cancelar",
                  onOk() {
                    duplicarFormulario(e.id);
                  },
                });
              }}
            />
          </Tooltip>
          <Tooltip title="Editar">
            <Button loading={loading} onClick={() => carregarFormulario(e.id)} icon={<EditOutlined />} />
          </Tooltip>
          <Tooltip title="Excluir">
            <Button
              danger
              loading={loading}
              icon={<DeleteOutlined />}
              onClick={() => {
                modal.confirm({
                  title: "Deseja deletar este registro?",
                  okText: "Sim",
                  cancelText: "Cancelar",
                  onOk() {
                    deletarFormulario(e.id);
                  },
                });
              }}
            />
          </Tooltip>
        </Space.Compact>
      ),
    },
  ];

  // SUBMIT FORM
  const onSubmit = (formulario) => {
    if (idAlt > 0) {
      formulario.id = idAlt;
      alterarFormulario(formulario);
    } else {
      cadastrarFormulario(formulario);
    }
  };

  // FORMULÁRIO
  const modalFormulario = (
    <Modal
      title={
        <Text style={{ fontSize: 20 }}>
          <EditOutlined /> {idAlt > 0 ? "Editar" : "Adicionar"} Formulário
        </Text>
      }
      open={showModal}
      onOk={() => form.submit()}
      okText="Salvar"
      width={1200}
      okButtonProps={{ size: "large", loading: loading }}
      cancelButtonProps={{ size: "large", loading: loading }}
      onCancel={() => {
        setShowModal(false);
        resetForm();
      }}>
      <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item name="descricao" label="Descrição" rules={[{ required: true, message: "Digite a descrição!" }]}>
              <Input size="large" disabled={loading} placeholder="Informe a descrição" />
            </Form.Item>
          </Col>

          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item
              name="id_cad_cargos_estrutura"
              label="Classificação"
              rules={[{ required: true, message: "Selecione a classificação!" }]}>
              <Select
                size="large"
                placeholder="Selecione a classificação"
                disabled={loading}
                style={{ width: "100%" }}
                options={classificacoes}
              />
            </Form.Item>
          </Col>

          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item name="status" label="Status" rules={[{ required: true, message: "Selecione o status!" }]}>
              <Select
                size="large"
                placeholder="Selecione o status"
                disabled={loading}
                style={{ width: "100%" }}
                options={options_status}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );

  return (
    <Row align="middle" justify="center" className="content-row">
      {modalFormulario}
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Avaliações" onClickBack={() => navigate("/")} />
            <HeaderTitle
              title="Avaliações Gestão Formulários"
              subtitle="Cadstrar avaliações formulários"
              icon={<UnorderedListOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <TableCustom
                extraHeaderComponents={
                  <Tooltip title="Adicionar Registro">
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={() => {
                        setShowModal(true);
                        resetForm();
                      }}
                      loading={loading}>
                      Novo
                    </Button>
                  </Tooltip>
                }
                loading={loading}
                columns={columns}
                dataSource={dados}
              />
            </Card>
          </div>
        </Col>
      </Col>
      {contextHolder}
    </Row>
  );
};
